import type { NuxtApp } from '#app/nuxt';
import { defineNuxtPlugin } from '#imports';
import { initGtag } from '../utils/gtag/init';
import { registerGtagRouter, requestCallback } from '../utils/gtag/registerRouterHook';
import { defer } from '../utils/requestIdleCallback';

export default defineNuxtPlugin((nuxt: NuxtApp) => {
    /** Ensure this plugin only runs on the client side. */
    if (!process.client) {
        return;
    }

    defer(async () => {
        await initGtag(nuxt);
    })
});